import { C24LocationCardsProps } from './C24LocationCards.types';
import { LocationCards } from '@ahc-digital/component-library';
import { CreateLocationCardsModel } from './C24LocationCards.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C24LocationCardsProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <LocationCards
      {...CreateLocationCardsModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
